import { useEffect } from "react";
import image4 from "../../../Assets/Home/Commitment/laboratoryImage.png";
import image5 from "../../../Assets/Home/Commitment/commitmentmage2.jpg";
import laboratory from "../../../Assets/Home/Commitment/laboratory.png";
import research from "../../../Assets/Home/Commitment/researchcenter.png";
import HeadingTexts from "../../common/HeadingTexts";
import { useNavigate } from "react-router-dom";

const Commitment = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const el = document.querySelector(".counter-text");
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          let start = 0;
          const end = 15;
          const duration = 2000;
          const increment = Math.ceil(end / (duration / 30));

          const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
              start = end;
              clearInterval(timer);
            }
            el.textContent = start + "+";
          }, 100);
          observer.unobserve(el);
        }
      },
      { threshold: 0.5 }
    );

    if (el) observer.observe(el);
  }, []);

  return (
    <div className="bg-[#fafafa]">
      <div className="grid lg:grid-cols-2 gap-4 grid-cols-1  md:px-10 px-6 pt-6">
        <div
        >
          <HeadingTexts
            label="Our commitments"
            text="Bringing World-Class Diagnostics to"
            bluetext="Closer to Every Indian"
          />
          <p data-aos="fade-up" data-aos-duration="700" className=" text-sm md:text-[1rem] font-normal leading-relaxed max-w-2xl text-[#5a5a5a] mb-5">
            We are dedicated to bringing world-class pathology services to every corner of India, ensuring accessible, affordable, and trustworthy diagnostics for all.
          </p>
          <p data-aos="fade-up" data-aos-duration="700" className=" text-sm md:text-[1rem] font-normal leading-relaxed max-w-2xl text-[#5a5a5a] mb-5">
            Delivering cutting-edge scientific services with precise testing,
            research support, and consultation, committed to excellence and
            advancement in every project.
          </p>
          <ul className="grid md:grid-cols-2 grid-cols-1 md:gap-6">
            <div>
              <li data-aos="fade-up" data-aos-duration="700" className="flex gap-2 items-center text-sm md:text-lg font-normal mb-5 leading-relaxed ">
                <img src={laboratory} className="h-16" />
                <h2 className="font-semibold familjen-font w-[60%] familjen-font">
                  Medical laboratory Technician
                </h2>
              </li>
              <div className="h-0.5 my-10 bg-gray-100"></div>
            </div>
            <div>
              {" "}
              <li data-aos="fade-up" data-aos-duration="700" className="flex gap-2 items-center text-sm md:text-lg font-normal mb-5 leading-relaxed ">
                <img src={research} className="h-16" />
                <h2 className="font-semibold familjen-font w-[60%] familjen-font">
                  10+ Quality Research Center
                </h2>
              </li>
              <div className="h-0.5 my-10 bg-gray-100"></div>
            </div>
          </ul>

          <div className="grid md:grid-cols-2 grid-cols-1">
            <div>
              <p data-aos="fade-up" data-aos-duration="700" className=" max-w-2xl text-[#5a5a5a] text-sm md:text-lg font-normal mb-5 leading-relaxed">
                New evidence has been published on the protein dosing patients.
              </p>
            </div>
            <div>
              <p data-aos="fade-up" data-aos-duration="700" className=" max-w-2xl text-[#5a5a5a] text-sm md:text-lg font-normal mb-5 leading-relaxed">
                We believe in fostering collaboration, innovation, and a
                knowledge.
              </p>
            </div>
          </div>
          <button data-aos="fade-up" data-aos-duration="700"
            onClick={() => {
              navigate("/about");
              window.scrollTo(0, 0);
            }}
            className="uppercase familjen-font bg-black text-white rounded-sm py-4 font-semibold px-8 mt-5"
          >
            More About Us
          </button>
        </div>
        <div
          className="relative"
        >
          <figure data-aos="fade-up" data-aos-duration="700" className="polygon-clip xl:h-[90%] lg:w-full">
            <img
              src={image4}
              alt="img"
              className="h-full w-full object-cover object-center"
            />
          </figure>
          <div data-aos="fade-up" data-aos-duration="700" className="polygon-clip familjen-font text-sm md:text-lg content-center absolute left-5 xl:bottom-20 lg:bottom-28 md:bottom-10 -bottom-5 bounce bg-primaryColor md:h-48 md:w-48 sm:h-32 sm:w-32 h-28 w-28 text-white font-bold text-center">
            <span className="md:text-4xl text-3xl counter-text">15+</span>
            <br />
            Years of <br /> Experience
          </div>
          <figure data-aos="fade-up" data-aos-duration="700" className="polygon-clip md:h-32 md:w-32 sm:h-24 w-20 sm:w-24 h-20 absolute right-0 xl:bottom-28 lg:bottom-40 md:bottom-20 bottom-[5%] ">
            <img
              src={image5}
              alt="img"
              className="w-full h-full object-cover object-center"
            />
          </figure>
        </div>
      </div>

      {/* <div className="marquee-container py-6" style={{ "--speed": "15s" }}>
        <div data-aos="fade-up" data-aos-duration="700" className="marquee-content">
          <span className="uppercase text-[3rem] md:text-[6rem] lg:text-[8rem] font-bold tracking-widest text-gray-800 px-8">
            <span className="text-primaryColor pl-4">Team Member</span> Expert{" "}
            <span className="text-primaryColor pr-20">Team</span>
          </span>
          <span className="uppercase text-[3rem] md:text-[6rem] lg:text-[8rem] font-bold tracking-widest text-gray-800 px-8">
            <span className="text-primaryColor">Team Member</span> Expert{" "}
            <span className="text-primaryColor">Team</span>
          </span>
        </div>
      </div> */}
    </div>
  );
};

export default Commitment;
